export default "https://cdn-static.gokick.com/assets/ecb6814e4f4fd856ee5e2a82e5f087b2e6d90ad2/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";